import $ from "jquery";

const addressenActive = () => {
  const init = () => {
    action();
  };

  const action = () => {
    $(document).ready(function($) {

      var currentUrl = window.location.href;      
    
      var domainUrl = window.location.origin; 
    
    var targetUrl = domainUrl + '/mijn-account/add-custom-address/';
 
      if (currentUrl === targetUrl) {
        
          $('.woocommerce-MyAccount-navigation-link.woocommerce-MyAccount-navigation-link--edit-address').addClass('is-active');
      }
  });
  };

  init();
};

try {
  addressenActive();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
